export const STAGE_ORDER = ["object", "devices", "pipes", "estimates"] as const;

export type Stage = (typeof STAGE_ORDER)[number];

/** completedStages — только начало STAGE_ORDER, без дыр и без чужого порядка. */
export function isCompletedStagesPrefix(
  completedStages: readonly Stage[],
): boolean {
  return completedStages.every((stage, index) => stage === STAGE_ORDER[index]);
}

/** Доступны все подтверждённые этапы плюс следующий. В document не хранится. */
export function getUnlockedStages(
  completedStages: readonly Stage[],
): Stage[] {
  const nextIndex = completedStages.length;
  return STAGE_ORDER.slice(0, Math.min(nextIndex + 1, STAGE_ORDER.length));
}
